exports = module.exports = require("../../../../../lunch-team-client-checkout-msg/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".main{padding:40px 20%}.head{width:100%;display:flex;align-items:center;justify-content:center;margin-bottom:60px}.content-terms .text-content{font-size:14px}.content-terms .back-link{color:#0e7a4b;font-size:16px;padding-bottom:20px}.content-terms .back-link:hover{text-decoration:underline}.content-terms p{padding:10px 0}.content-terms h2{font-size:28px;font-weight:bold;text-transform:unset;margin-bottom:40px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../lunch-team-client-checkout-msg/node_modules/css-loader!../lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./src/containers/Landing/PrivacyTerms/privacyTerms.scss
// module id = 945
// module chunks = 7